<template>
  <v-card class="mx-auto" flat>
    <div class="text-body-1 font-weight-medium mt-2 ml-2">Attach Your CV</div>
    <v-card-actions>
      <v-btn
        color="primary"
        v-if="cvAttachment"
        class="mt-2"
        block
        @click="viewAttachment()"
      >
        <v-icon>mdi-file-pdf</v-icon>
        Preview CV Attachment
      </v-btn>
    </v-card-actions>
    <v-card-actions>
      <v-file-input
        accept="application/pdf"
        :rules="rules.cvAttachment"
        dense
        prepend-icon="mdi-paperclip"
        outlined
        persistent-placeholder
        placeholder="Attach CV"
        @change="handleFileChange"
        ><template v-slot:label>
          <div>
            Attachment
            <span class="red--text">*</span>
          </div>
        </template></v-file-input
      >
      <span
          style="color: red; display: block; margin-top: 4px; padding-inline: 8px;"
          v-if="fileUploadError"
      >
  {{ fileUploadError }}
</span>
    </v-card-actions>
    <v-dialog
      v-model="viewAttachmentDialog"
      v-if="cvAttachment"
      persistent
      width="80%"
    >
      <v-card class="mx-auto">
        <v-card-title class="file--title">
          <div class="text-lg-h5 font-weight-bold mr-2">CV Attachment</div>
          <v-btn
            color="primary"
            class="mt-2"
            @click="downloadFile(cvAttachment.attachment)"
          >
            Download
          </v-btn>
          <v-spacer />
          <v-btn icon @click="viewAttachmentDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <pdf :src="`data:application/pdf;base64,${cvAttachment.attachment}`" />
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import pdf from "vue-pdf";
import FileMixin from "@/mixin/FileMixin";
export default {
  name: "cvBio",
  mixins: [FileMixin],
  components: {
    pdf,
  },
  props: {
    rules: {
      type: Object,
      default: () => ({}),
    },
    profile: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      viewAttachmentDialog: false,
      fileUploadError: "",
    };
  },
  computed: {
    cvAttachment() {
      const attachments =
        this.$store.getters["Profile/attachmentGetters"]("attachments");
      return attachments
        ? attachments.find((attachment) => attachment.documentCode === "CV")
        : undefined;
    },
  },
  methods: {
    handleFileChange(file) {
      this.fileUploadError = "";

      if (!file) return;

      if (file.size > 10 * 1024 * 1024) {
        this.fileUploadError = "File size exceeds 10MB";
        return;
      }

      const fileReader = new FileReader();

      fileReader.onload = () => {
        const base64String = fileReader.result.split(",")[1]; // Strip the "data:..." prefix

        const payload = {
          attachment: base64String,
          documentCode: "CV",
          relatedRecordId: this.profile.id,
          profileID: this.profile.profileID,
          current: true,
        };

        if (this.cvAttachment) {
          payload.id = this.cvAttachment.id;
          this.$store.dispatch("Profile/updateAttachments", payload);
        } else {
          this.$store.dispatch("Profile/saveMandatoryAttachment", payload);
        }
      };

      fileReader.readAsDataURL(file);
    },
    viewAttachment() {
      this.viewAttachmentDialog = true;
    },
  },
};
</script>
<style>
.file--title {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: #fff;
}
</style>
